import device from '@@/bits/device'
import { getAndClearSearchParam } from '@@/bits/location'
import { WallCreatedFrom } from '@@/enums'
import { usePostComposerModalStore } from '@@/pinia/post_composer_modal_store'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfaceDraftsStore } from '@@/pinia/surface_drafts'
import { useSurfaceMapStore } from '@@/pinia/surface_map'
import { useSurfaceOnboardingPanelStore } from '@@/pinia/surface_onboarding_panel'
import { useSurfacePermissionsStore } from '@@/pinia/surface_permissions'
import { useSurfacePostsStore } from '@@/pinia/surface_posts'
import { useSurfaceStartingStateStore } from '@@/pinia/surface_starting_state'
import { storeToRefs } from 'pinia'
import type { Ref } from 'vue'
import { watch } from 'vue'

function useOpenComposerOnArrival(): void {
  const isOpenComposerLink = getAndClearSearchParam('open_composer') === '1'
  const type = useSurfaceStartingStateStore().startingState.onboardingFlow?.wallCreatedFromType
  if (!isOpenComposerLink && type !== WallCreatedFrom.PromptMake) return

  const { hasFetchedInitialPostDrafts } = storeToRefs(useSurfaceDraftsStore())
  openWhenReady(hasFetchedInitialPostDrafts, openComposer)
}

function openWhenReady(hasFetched: Ref<boolean>, open: () => Promise<void>): void {
  if (hasFetched.value) {
    void open()
    return
  }
  const unwatch = watch(hasFetched, async (fetched) => {
    if (!fetched) return
    unwatch()
    await open()
  })
}

async function openComposer(): Promise<void> {
  useSurfaceOnboardingPanelStore().closeOnboardingPanel()
  if (device.app) return
  if (!useSurfacePermissionsStore().canIPost) return
  if (usePostComposerModalStore().hasActiveComposerModal) return
  if (useSurfaceStore().isMap) {
    useSurfaceMapStore().startPickingLocation()
    return
  }
  await useSurfacePostsStore().startNewPost({})
}

export { useOpenComposerOnArrival }
